export const SPARTAN_PRODUCT_HERO_READY_EVENT = 'spartan-product-hero-ready';
export const SPARTAN_PRODUCT_LAYOUT_WILL_CHANGE_EVENT =
  'spartan-product-layout-will-change';
export const SPARTAN_PRODUCT_LAYOUT_DID_CHANGE_EVENT =
  'spartan-product-layout-did-change';

const SPARTAN_PRODUCT_HERO_READY_ATTRIBUTE = 'data-spartan-hero-ready';

export const markSpartanProductHeroReady = () => {
  document.documentElement.setAttribute(
    SPARTAN_PRODUCT_HERO_READY_ATTRIBUTE,
    ''
  );
  window.dispatchEvent(new Event(SPARTAN_PRODUCT_HERO_READY_EVENT));
};

export const clearSpartanProductHeroReady = () => {
  document.documentElement.removeAttribute(
    SPARTAN_PRODUCT_HERO_READY_ATTRIBUTE
  );
};

export const isSpartanProductHeroReady = () =>
  document.documentElement.hasAttribute(SPARTAN_PRODUCT_HERO_READY_ATTRIBUTE);

export const notifySpartanProductLayoutWillChange = () => {
  window.dispatchEvent(new Event(SPARTAN_PRODUCT_LAYOUT_WILL_CHANGE_EVENT));
};

export const notifySpartanProductLayoutDidChange = () => {
  window.dispatchEvent(new Event(SPARTAN_PRODUCT_LAYOUT_DID_CHANGE_EVENT));
};
